import React, { useEffect, useState } from "react";
import Instance from "../../Utils/Axios";
import "./Footer.css";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Footer() {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    Instance.get("/site/footer")
      .then((response) => {
        setFooterData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError("Error fetching footer data");
        setLoading(false);
        console.error("Error fetching footer data:", error);
      });
  }, []);

  if (loading) return null;
  if (error || !footerData) return null;

  return (
    <>
      <footer className="new_footer_area">
        <div className="footer_inner_container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
          <div className="row footer_top_row">
            {/* Column 1: YOUR LOGO / Contact */}
            <div className="col-lg-3 col-md-6 footer_col company_col">
              <div className="footer_title_box">
                <img src="/build/Logo.svg" alt="Logo" className="footer_logo" />
              </div>
              <div className="contact_info_box">
                <p>
                  <i className="bi bi-envelope"></i> {footerData.email}
                </p>
                <p>
                  <i className="bi bi-telephone"></i> {footerData.contact}
                </p>
                <p>
                  <i className="bi bi-geo-alt"></i> <span>{footerData.address}</span>
                </p>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="col-lg-3 col-md-6 footer_col">
              <div className="footer_title_box footer_section_title">
                <h4>Quick Links</h4>
              </div>
              <ul className="footer_link_list">
                {footerData.quickLinks?.map((link, index) => (
                  <li key={index}>
                    <Link to={link.rUrl} target={link.target || "_self"}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: Submit PR */}
            <div className="col-lg-3 col-md-6 footer_col">
              <div className="footer_title_box footer_section_title">
                <h4>Submit PR</h4>
              </div>
              <ul className="footer_link_list">
                {footerData.submitPR?.map((link, index) => (
                  <li key={index}>
                    <Link to={link.rUrl} target={link.target || "_self"}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 4: Follow Us */}
            <div className="col-lg-3 col-md-6 footer_col no_border_col">
              <div className="footer_title_box footer_section_title">
                <h4>Follow Us</h4>
              </div>
              <div className="social_links_box">
                {footerData.social?.map((item, index) => (
                  <a
                    key={index}
                    href={item.rUrl}
                    target={item.target || "_blank"}
                    rel="noopener noreferrer"
                    className="social_icon"
                  >
                    <i className={`bi ${item.icon}`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="footer_bottom_row">
                <div className="footer_bottom_content">
                  <span>{footerData.copyRight}</span>
                  <span className="footer_divider">|</span>
                  <Link
                    to={footerData.privacyPolicy?.rUrl}
                    target={footerData.privacyPolicy?.target || "_self"}
                  >
                    {footerData.privacyPolicy?.label}
                  </Link>
                  <span className="footer_divider">|</span>
                  <Link
                    to={footerData.editorialGuidelines?.rUrl}
                    target={footerData.editorialGuidelines?.target || "_self"}
                  >
                    {footerData.editorialGuidelines?.label}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
